import { Injectable, signal } from '@angular/core';
import { Toast, ToastType } from '@shared/ui/cnfpc-toast/model/toast.model';

@Injectable({
  providedIn: 'root',
})
export class CnfpcToastService {
  // Collection de toasts actuellement affichés
  toasts = signal<Toast[]>([]);

  // Durée par défaut en millisecondes
  private defaultDuration = 3500;

  constructor() {}

  /**
   * Ajoute un nouveau toast
   */
  show(message: string, type: ToastType = 'info', duration?: number): string {
    const id = this.generateId();

    const toast: Toast = {
      id,
      message,
      type,
      duration: duration || this.defaultDuration,
    };

    // Ajouter le toast à la liste
    this.toasts.update((current) => [...current, toast]);

    // Programmer la suppression automatique
    setTimeout(() => {
      this.remove(id);
    }, toast.duration);

    return id;
  }

  /**
   * Raccourcis pour les différents types de toast
   */
  success(message: string, duration?: number): string {
    return this.show(message, 'success', duration);
  }

  error(message: string, duration?: number): string {
    return this.show(message, 'error', duration);
  }

  info(message: string, duration?: number): string {
    return this.show(message, 'info', duration);
  }

  warning(message: string, duration?: number): string {
    return this.show(message, 'warning', duration);
  }

  /**
   * Supprime un toast spécifique
   */
  remove(id: string): void {
    this.toasts.update((current) => current.filter((toast) => toast.id !== id));
  }

  /**
   * Supprime tous les toasts
   */
  clear(): void {
    this.toasts.set([]);
  }

  /**
   * Génère un identifiant unique
   */
  private generateId(): string {
    return `toast-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
  }
}
